import React from "react";
import { Container } from 'react-bootstrap';
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { Helmet } from "react-helmet-async";

const CareerScreen = () => {

    const handleApplyClick = () => {
        window.open('https://forms.gle/8iXoRRUNbLsACL3p8', '_blank');
    };
    return <>
        <Helmet>
            <title>Career</title>
            <meta name="description" content=" Oasis Educational Institute" />
        </Helmet>
        <div>

            <Breadcrumbs page="Careers" label="Home" path="/" />
            <Container style={{ marginTop: '3%', marginBottom: '5%', padding: '20px' }}>
                <div className="mt-[5%] mb-[5%] px-5">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-black-700 mb-4">Job Application Form 2025</h1>
                        <p className="text-gray-600">Join our team and take the next step in your career. Fill out the form below to apply for exciting opportunities.</p>
                    </div>

                    <div className="flex justify-center">
                        <button
                            onClick={handleApplyClick}
                            className="bg-blue-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors"
                        >
                            Fill Out Job Application Form
                        </button>
                    </div>
                </div>
            </Container>
        </div>
    </>;
};

export default CareerScreen;
